import { AppDispatch } from '../../store'
import { updateConfiguration } from '../../global-state/investor-slice'
import { kycServices } from '../../services'

export type InvestorKycState = {
  kycStatus: string
  acceptedNDA: boolean
  clientAgreementSigned: boolean
}

export const fetchInvestorKycState = async (
  userId: number,
  authToken: string,
): Promise<InvestorKycState | null> => {
  const response = await kycServices.getKYC_v1(userId.toString(), {
    Authorization: authToken || '',
  })

  if (response?.status !== 200 || !response?.data) {
    return null
  }

  const { status, is_nda_accepted, client_agreement_signed } = response.data

  return {
    kycStatus: status || '',
    acceptedNDA: !!is_nda_accepted,
    clientAgreementSigned: !!client_agreement_signed,
  }
}

export const applyInvestorKycStateToStore = (dispatch: AppDispatch, kycState: InvestorKycState) => {
  if (kycState.kycStatus) {
    dispatch(updateConfiguration({ name: 'kycStatus', value: kycState.kycStatus }))
  }

  dispatch(updateConfiguration({ name: 'acceptedNDA', value: kycState.acceptedNDA }))
}
